import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const PhotoPosters = () => {

  const servicesFaqData = [
    {
        question: "What are photo posters, and where are they used?",
        answer: "Photo posters are high-resolution prints for walls, displays, or promotional use. They showcase images, artwork, or branding in vibrant detail, commonly used in retail stores, offices, events, and homes. Businesses often use photo posters to advertise, while individuals opt for personalized posters to decorate their spaces. The versatility of photo posters makes them suitable for professional and personal use. Whether for a promotional display or decorative wall art, photo posters creatively share visuals."
    },
    {
        question: "What are the benefits of custom photo poster printing?",
        answer: "Custom photo poster printing allows you to create personalized designs that reflect your brand, style, or message. With customization, you can include logos, text, or unique imagery to make your poster stand out. The high-resolution printing ensures sharp details and vibrant colours, making your posters visually appealing. Custom photo posters are available in multiple sizes, making them suitable for various display areas, from large walls to compact spaces. Additionally, they are printed on durable materials, ensuring longevity and value for money."
    },
    {
        question: "Can Printingy handle bulk orders for photo poster printing?",
        answer: "Yes, Printingy specializes in bulk photo poster printing, offering cost-effective solutions for large-scale orders. Bulk printing reduces per-unit costs, making it an economical choice for businesses or events requiring multiple posters. We use advanced technology to ensure consistent quality across all prints, regardless of the order size. Bulk orders are ideal for promotional campaigns, corporate branding, or event decorations. Printingy’s efficient production process guarantees timely delivery without compromising on quality."
    },
    {
        question: "What materials are used for personalized photo poster prints?",
        answer: "Our personalized photo poster prints are produced using high-quality photo paper, canvas, or durable vinyl materials. Photo paper is ideal for vibrant colours and sharp details, perfect for indoor displays. Canvas adds a textured, artistic look to your posters, making them suitable for decor. Vinyl materials are durable and water-resistant, making them ideal for outdoor displays or long-term use. Each material is carefully selected to enhance your photo posters' visual appeal and durability, ensuring a professional finish."
    },
    {
        question: "What industries benefit from photo poster printing services?",
        answer: "Retail, hospitality, education, and entertainment industries benefit significantly from photo poster printing services. Retailers use photo posters to promote products and sales in stores or window displays. Hospitality businesses rely on posters for decor, event promotions, and seasonal branding. Educational institutions use them to create visually engaging learning materials or event advertisements. Entertainment companies often use photo posters for promotional campaigns, concerts, and film advertising. The versatility of photo posters makes them an effective communication tool across various sectors."
    }
  ];
  const [pageTitle, setPageTitle] = useState('Printing of Photo Posters');  // Dynamic title state

useEffect(() => {
  document.title = pageTitle; // Set the document title dynamically
}, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title="Custom Photo Poster Printing Services"
  description="High-quality printing of photo posters for walls and displays. Bulk custom photo poster printing, personalized photo poster prints, and professional photo poster printing solutions."
  keywords="Printing of Photo Posters,
Photo Posters Printing,
Custom Photo Poster Printing,
Personalized Photo Poster Prints,
Photo Poster for Wall Printing"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing of Photo Posters</h1>
              <h2 className="text-muted">
              Customized photo posters for walls, events, and displays
              </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Photo posters are a timeless way to showcase memories, artwork, or promotional content with vibrant and detailed visuals. Printingy specializes in Printing Photo Posters, offering high-quality photo poster printing solutions for businesses and individuals.</p>
          <p>Our services include Custom Photo Poster Printing, allowing you to personalize designs to align with your branding or decor. For unique displays, we also provide personalized photo poster prints tailored for retail spaces, events, or personal collections. Whether for promotional campaigns or decorative wall art, our photo poster for wall printing ensures precision and vibrant colours that leave a lasting impact.</p>
        
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row className="al-center"> 
              <Col lg={6}>
              <h2 className="small-hed">Reliable Custom Photo Poster Printing Solutions</h2>
                <h3 className="large-hed">High-quality, vibrant, and personalized photo posters for all purposes</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Printing of Photo Posters for branding, decor, and events.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk photo posters printing with cost-effective pricing.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Fully tailored custom photo poster printing to meet your unique needs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional, personalized photo poster prints with premium materials.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    High-resolution visuals with vibrant and fade-resistant colours.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Multiple size options for versatile displays.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for bulk and customized orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted solutions for businesses, event organizers, and personal projects.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/photoposter.jpg" // Path relative to the public folder
                  alt="Professional printing of photo posters services"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
       title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Photo Posters Delivered On Time</h2>
            <h3 className="small-hed">Focus on your creativity while we manage your photo poster printing needs</h3>
            <p>At Printingy, we combine advanced printing techniques with premium materials to produce exceptional photo poster printing. Whether for advertising, decor, or personal use, our Custom Photo Poster Printing services ensure that your posters are visually striking and durable.</p>
            <p>We guarantee timely delivery for all bulk orders, ensuring your posters are ready when needed. Partner with Printingy for reliable and professional photo poster printing solutions.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default PhotoPosters;
